export default "__VITE_ASSET__CCv19lbQ__"